import React from "react";
import { EmblaOptionsType } from "embla-carousel";
import { useDotButton } from "./ProductCardCarouselDotButton";
import "./ProductCarousel.scss";
import useEmblaCarousel from "embla-carousel-react";
import { MdKeyboardArrowLeft, MdKeyboardArrowRight } from "react-icons/md";
import { usePrevNextButtons } from "./ProductCardCarouselArrow";
import { useProductQuery } from "../../../hooks/useReactQuery";
import { Link } from "react-router-dom";

const ProductCarousel: React.FC = (props) => {
  const option: EmblaOptionsType = { align: "start" };
  const [emblaRef, emblaApi] = useEmblaCarousel(option);

  const { selectedIndex, scrollSnaps, onDotButtonClick } =
    useDotButton(emblaApi);

  const { Prefetch: getAllProductsQuery } = useProductQuery();
  const getAllProducts = getAllProductsQuery();

  const {
    prevBtnDisabled,
    nextBtnDisabled,
    onPrevButtonClick,
    onNextButtonClick,
  } = usePrevNextButtons(emblaApi);

  return (
    <section className="product_carousel_container">
      <div className="flex justify-between items-center pb-8">
        <div className="lg:text-[35px] sm:text-[30px] text-[25px] font-medium">
          You might also like
        </div>
        <div className="flex items-center gap-[10px]">
          <button
            className="bg-[#232321] text-[#E7E7E3] rounded-[10px] w-[40px] h-[40px] flex justify-center items-center cursor-pointer  disabled:bg-gray-500"
            onClick={onPrevButtonClick}
            disabled={prevBtnDisabled}
          >
            <MdKeyboardArrowLeft size={22} />
          </button>
          <button
            className="bg-[#232321] text-[#E7E7E3] rounded-[10px] w-[40px] h-[40px] flex justify-center items-center cursor-pointer disabled:bg-gray-500"
            onClick={onNextButtonClick}
            disabled={nextBtnDisabled}
          >
            <MdKeyboardArrowRight size={22} />
          </button>
        </div>
      </div>
      <div className="" ref={emblaRef}>
        {getAllProducts.data?.data !== undefined ? (
          <div className="product_carousel">
            {getAllProducts.data?.data.slice(0, 8).map((product, index) => (
              <Link
                to={`/product-details/${product._id}`}
                className="product_carousel_cards"
                key={index}
                onClick={() => {
                  window.scrollTo(0, 0);
                }}
              >
                <div className="product_card">
                  <div className="img_wrapper">
                    <div className="product_img">
                      <img src={product.images[0]} alt="" loading="lazy" />
                      <div className="img_bridge">New</div>
                    </div>
                  </div>
                  <div className="product_name">{product.name}</div>
                  <div className="product_price">
                    View Product -{" "}
                    <span className="text-[#FFA52F]">₹{product.price}</span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        ) : (
          <div className="product_carousel">
            {[...Array(8)].map((_, index) => (
              <div className="product_carousel_cards" key={index}>
                <div className="skeleton_card">
                  <div className="skeleton_image" />
                  {/* <div className="skeleton_text short" /> */}
                  <div className="skeleton_text" />
                  <div className="skeleton_button" />
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      <div className="carousel_dots_container">
        {scrollSnaps.map((_, index) => {
          return (
            <div
              key={index}
              className={`carousel_dots ${
                index === selectedIndex && "active_slide"
              }`}
              onClick={() => onDotButtonClick(index)}
            ></div>
          );
        })}
      </div>
    </section>
  );
};

export default ProductCarousel;
